import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class BankAccountAddedNotifierService {

  newBankAccountSubject=new Subject<NewBankAccountResponse>();

  //Function To Emit Value Or Push Value
  pushStatusNotification(newBankAccount:NewBankAccountResponse){

    this.newBankAccountSubject.next(newBankAccount);
  }

  //Function To Receive Value When Value is Emited
  getStatusNotification():Observable<NewBankAccountResponse>{
    return this.newBankAccountSubject;
  }
}
export interface NewBankAccountResponse{
account_number: string,
arabic_bank_name:string,
arabic_branch_name:string;
holder_name: string,
}
